'use strict';

import angular from 'angular';

const sectionsServices = angular.module('applicationModule.sectionsServices', []);

sectionsServices.factory('Section', ['$http', 'Upload', 'AppsoupAPI', function ($http, Upload, AppsoupAPI) {
    const SECTION_URL = AppsoupAPI.API_URL + '/page/';

    const checkFiles = function (file) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }

        return {files: files, names: names};
    };

    return {
        getList: function (appId, params, clientId) {
            const url = SECTION_URL + (angular.isDefined(clientId) ? 'client-permitted/' + clientId : '');

            return $http.get(url, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})}).then(function (response) {
                return response.data;
            });
        },
        getSectionsList: function (appId) {
            const url = SECTION_URL + 'get-all';

            return $http.get(url, {params: {application_id: appId}});
        },
        get: function (pageId) {
            return $http.get(SECTION_URL + pageId);
        },
        getSectionTags: function (appId) {
            return $http.get(SECTION_URL + 'create', {params: {application_id: appId}});
        },
        save: function (page, editMode, file) {
            if (editMode) {
                if (angular.isDefined(file)) {
                    const files = checkFiles(file);
                    const newfields = angular.extend(page, {_method: 'PUT'});

                    return Upload.upload({
                        url: SECTION_URL + page.id,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(SECTION_URL + page.id, page);
                }
            } else {
                if (angular.isDefined(file)) {
                    const filee = checkFiles(file);

                    return Upload.upload({
                        url: SECTION_URL,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: page,
                        file: filee.files,
                        fileFormDataName: filee.names
                    });
                } else {
                    return $http.post(SECTION_URL, page);
                }
            }
        },
        remove: function (pageId) {
            return $http.delete(SECTION_URL + pageId);
        }
    };
}]);

export default sectionsServices;
